import React from "react";
import { Link } from "react-router-dom";
import { HomeSectionLink } from "../../shared/homeSectionNav";
import { serviceItems } from "../data";

function ServiceCta({ item }) {
  const className =
    "custom-btn custom-btn-primary no-underline mt-auto self-start";

  if (item.to === "/download-app") {
    return (
      <HomeSectionLink to={item.to} className={className}>
        {item.cta}
      </HomeSectionLink>
    );
  }

  return (
    <Link to={item.to} className={className}>
      {item.cta}
    </Link>
  );
}

function ServicesSection() {
  return (
    <section className="service-section py-10 md:py-16 relative overflow-hidden bg-gray-50">
      <div className="container">
        <div className="max-w-[950px] mx-auto text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-2 tracking-[.2em] body-lg">
            <span className="w-[33px] h-[1px] bg-primary-500 inline-block"></span>
            SERVICES
          </span>
          <h2 className="web-h2 text-zinc-900 mt-3">
            Discover what resonates with you
          </h2>
          <p className="web-body-sm text-zinc-600 mt-2">
            Different questions call for different perspectives. Explore the
            services and experiences available on AstroAdi.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[15px] md:gap-[24px]">
          {serviceItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col gap-[12px] bg-white border border-gray-200 rounded-[20px] py-[20px] lg:py-[28px] px-[18px] lg:px-[24px]"
            >
              <img
                src={item.icon}
                alt=""
                className="w-[64px] h-[64px] md:w-[80px] md:h-[80px] rounded-full aspect-[1/1] object-cover"
              />
              <h3 className="web-h4">{item.title}</h3>
              <p className="web-body-sm text-zinc-600 !leading-relaxed">
                {item.description}
              </p>
              <ServiceCta item={item} />
            </div>
          ))}
        </div>
      </div>
      <div className="absolute top-[20%] left-0 hidden 2xl:block">
        <img src="/images/shape2.png" alt="" />
      </div>
    </section>
  );
}

export default ServicesSection;
